function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import Drawer from 'material-ui/Drawer';
import Loading from 'swag-client-common/components/info/loading';
import classnames from 'classnames';
import Clear from '@material-ui/icons/Clear';
import searchIconImage from 'assets/svg/search-icon.svg';
import MobileHeader from '../mobile-header';
import { is1024andSmaller } from '../../../utils/ui.utils';
import { hideIntercom } from '../../../../../scripts/customer/utils/ui.utils';
import classes from './search-products.scss';
import SearchResults from './components/search-results';
import NoResultsMessage from './components/no-results-message';
import SearchIcon from './components/search-icon';
const containerStyle = {
  overflow: 'visible'
};
export default class SearchProducts extends React.Component {
  constructor(...args) {
    // @ts-ignore
    super(...args);
    _defineProperty(this, "searchInput", void 0);
    this.onSearchFocus = this.onSearchFocus.bind(this);
    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.deactivate = this.deactivate.bind(this);
    this.clear = this.clear.bind(this);
    this.onPressEnter = this.onPressEnter.bind(this);
  }
  componentWillUnmount() {
    this.props.onPageScrollBlock(false);
  }
  onSearchFocus() {
    const {
      onFocus,
      onPageScrollBlock,
      ignoreMobileChanges = false
    } = this.props;
    if (is1024andSmaller() && !ignoreMobileChanges) {
      hideIntercom(true);
    }
    if (onFocus) {
      onFocus(is1024andSmaller() && !ignoreMobileChanges);
    }
    if (onPageScrollBlock) {
      onPageScrollBlock(is1024andSmaller() && !ignoreMobileChanges);
    }
    document.addEventListener('click', this.deactivate);
    localStorage.removeItem('productId');
  }
  onRootClick(e) {
    e.nativeEvent.stopImmediatePropagation();
  }
  onPressEnter(e) {
    const {
      query,
      onGoToSearchResultsPage
    } = this.props;
    if (e.charCode === 13 && query) {
      onGoToSearchResultsPage(query);
    }
  }
  handleLinkClick() {
    this.props.onLinkClick();
    this.deactivate();
  }
  clear() {
    const {
      onFocus,
      onSearch,
      onClear
    } = this.props;
    onClear();
    if (onFocus) {
      onFocus(false);
    }
    onSearch({
      target: {
        value: ''
      }
    });
  }
  deactivate() {
    const {
      onPageScrollBlock,
      onDeactivate,
      query,
      ignoreMobileChanges = false
    } = this.props;
    if (is1024andSmaller() && !ignoreMobileChanges) {
      hideIntercom();
    }
    onDeactivate(query);
    onPageScrollBlock(false);
    document.removeEventListener('click', this.deactivate);
  }
  render() {
    const {
      isActive,
      isSearchResultsShown,
      isLoading,
      searchResults,
      onSearch,
      query,
      total,
      noResults,
      isMobileIconShown,
      onGoToSearchResultsPage,
      searchSuggestions,
      ignoreMobileChanges = false
    } = this.props;
    const isMobileView = is1024andSmaller() && !ignoreMobileChanges;
    const activeInputClass = classes.isActive;
    const isRenderDrawer = isActive && isSearchResultsShown;
    const renderContent = () => /*#__PURE__*/React.createElement("div", {
      onClick: this.onRootClick,
      className: classnames(classes.container, {
        [activeInputClass]: isActive,
        [classes.bringForward]: isActive
      })
    }, /*#__PURE__*/React.createElement("img", {
      onClick: () => this.searchInput.focus(),
      src: searchIconImage,
      className: classes.desktopSearchIcon
    }), /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.innerContainer)
    }, isActive && /*#__PURE__*/React.createElement(MobileHeader, {
      onClose: this.deactivate,
      headerText: "search"
    }), /*#__PURE__*/React.createElement("input", {
      "data-element": "search",
      placeholder: isMobileView ? 'Type Something…' : 'Search',
      value: query,
      className: classes.input,
      onChange: onSearch,
      onKeyPress: e => this.onPressEnter(e),
      onFocus: this.onSearchFocus,
      ref: el => {
        // @todo. auto generated. fix this error
        // @ts-ignore
        this.searchInput = el;
      }
    }), !isActive && /*#__PURE__*/React.createElement("span", {
      onClick: () => this.searchInput.focus()
    }, /*#__PURE__*/React.createElement(SearchIcon, {
      className: classnames(classes.mobileSearchIcon, classes.icon, {
        [classes.showIcon]: isMobileIconShown
      })
    })), isActive && isSearchResultsShown && /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.resultBox, {
        [classes.noResults]: isLoading || noResults,
        [classes.noPadding]: !searchResults.length
      })
    }, isLoading && /*#__PURE__*/React.createElement(Loading, null), noResults && /*#__PURE__*/React.createElement(NoResultsMessage, null), searchResults && !isLoading && !noResults && /*#__PURE__*/React.createElement(SearchResults, {
      onLinkClick: this.handleLinkClick,
      onButtonClick: () => onGoToSearchResultsPage(query),
      searchResults: searchResults,
      total: total,
      searchSuggestions: searchSuggestions,
      onSuggestionClick: onSearch
    }))), /*#__PURE__*/React.createElement("div", {
      className: classes.desktopClearIconContainer
    }, !!query.length && /*#__PURE__*/React.createElement(Clear, {
      className: classes.desktopClearIcon,
      onClick: this.clear
    })));
    return isRenderDrawer && isMobileView ? /*#__PURE__*/React.createElement(Drawer, {
      docked: false,
      openSecondary: true,
      width: "100%",
      open: isRenderDrawer,
      containerStyle: containerStyle
    }, renderContent()) : renderContent();
  }
}